import React from 'react'
import Modal from 'scripts/components/modal/Modal'
import locale from 'shared/i18n/react'
import RenderCcpa from './RenderCcpa'
import { connect } from 'scripts/store'
import { Link } from 'react-router-dom'
import { isCcpaEligible } from 'scripts/helpers/CcpaHelper'

class CcpaLink extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      user: props.user
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ user: nextProps.user })
  }

  isUserLoggedIn() {
    return !!this.state.user
  }

  ccpaShowModal = () => {
    this.setState({ modalIsOpen: true })
  }

  ccpaHideModal = () => {
    this.setState({ modalIsOpen: false })
  }

  renderModal = () => {
    return <React.Fragment>
      <a href='javascript:;' onClick={this.ccpaShowModal}>{this.props.children}</a>
      <Modal
        center
        open={this.state.modalIsOpen}
        onClose={this.ccpaHideModal}
        closeOnOverlayClick={false}
        showCloseIcon={true}
        classNames={{modal: 'modal-ccpa-settings'}}
      >
        <h3 style={{ marginTop: '0px' }}>{locale.ccpaConsent.modalTitle}</h3>
        <RenderCcpa />
      </Modal>
    </React.Fragment>
  }

  renderUserProfileLink = () => {
    return <Link to='/user/edit'>{this.props.children}</Link>
  }

  renderInvalidOutput = () => {
    return this.props.children
  }

  render() {
    if (this.isUserLoggedIn()) {
      return this.renderUserProfileLink()
    } else if (!isCcpaEligible()) {
      return this.renderInvalidOutput()
    } else {
      return this.renderModal()
    }
  }
}

const mapToProps = ({user}) => {
  return {user}
}

export default connect(mapToProps)(CcpaLink)



// WEBPACK FOOTER //
// ./assets/js/lib/Ccpa/CcpaLink.jsx